// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncidentSeverity } from './IncidentSeverity';
import {
    IncidentSeverityFromJSON,
    IncidentSeverityFromJSONTyped,
    IncidentSeverityToJSON,
    IncidentSeverityToJSONTyped,
} from './IncidentSeverity';
import type { IncidentStatus } from './IncidentStatus';
import {
    IncidentStatusFromJSON,
    IncidentStatusFromJSONTyped,
    IncidentStatusToJSON,
    IncidentStatusToJSONTyped,
} from './IncidentStatus';

/**
 * 
 * @export
 * @interface IncidentQueryMeta
 */
export interface IncidentQueryMeta {
    /**
     * Room query condition that has been applied to the result
     */
    room?: string;
    /**
     * Device query condition that has been applied to the result
     */
    context?: string;
    /**
     * Device query condition that has been applied to filter for active state
     */
    active?: boolean;
    /**
     * Severity filter that has been applied to the result
     */
    severity?: Array<IncidentSeverity>;
    /**
     * 
     */
    status?: Array<IncidentStatus>;
}

/**
 * Check if a given object implements the IncidentQueryMeta interface.
 */
export function instanceOfIncidentQueryMeta(value: object): value is IncidentQueryMeta {
    return true;
}

export function IncidentQueryMetaFromJSON(json: any): IncidentQueryMeta {
    return IncidentQueryMetaFromJSONTyped(json, false);
}

export function IncidentQueryMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentQueryMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'room': json['room'] == null ? undefined : json['room'],
        'context': json['context'] == null ? undefined : json['context'],
        'active': json['active'] == null ? undefined : json['active'],
        'severity': json['severity'] == null ? undefined : ((json['severity'] as Array<any>).map(IncidentSeverityFromJSON)),
        'status': json['status'] == null ? undefined : ((json['status'] as Array<any>).map(IncidentStatusFromJSON)),
    };
}

export function IncidentQueryMetaToJSON(json: any): IncidentQueryMeta {
    return IncidentQueryMetaToJSONTyped(json, false);
}

export function IncidentQueryMetaToJSONTyped(value?: IncidentQueryMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'room': value['room'],
        'context': value['context'],
        'active': value['active'],
        'severity': value['severity'] == null ? undefined : ((value['severity'] as Array<any>).map(IncidentSeverityToJSON)),
        'status': value['status'] == null ? undefined : ((value['status'] as Array<any>).map(IncidentStatusToJSON)),
    };
}

